"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDtoRoleEnum = void 0;
exports.UserDtoRoleEnum = {
    Physician: 'physician',
    Patient: 'patient',
    LabDirector: 'lab_director',
    Staff: 'staff',
    Null: 'null'
};
